import en from '@account/locales/en_US/en';

const enUs = {
  en,
};

export default enUs;
